export const getKeyByValue = (enumType: any, value: any): number | string => {
  const keys = Object.keys(enumType);
  const index = keys.findIndex((key) => enumType[key] === value);
  return index !== -1 ? index : '';
};
